(function () {
	'use strict';

	angular.module('dcApp').factory('RepositoryHeadersService', [
		'GrammarUtils',
		'$sce',
		function (
			GrammarUtils,
			$sce
		) {
			var RepositoryHeadersService = {};

			RepositoryHeadersService.filterHeadersByCaracType = filterHeadersByCaracType;
			RepositoryHeadersService.getSourceTypeIgnoreCase = getSourceTypeIgnoreCase;
			RepositoryHeadersService.getHeaderHtmlIconByType = getHeaderHtmlIconByType;
			RepositoryHeadersService.isTypesCompatible = isTypesCompatible;

			const columnTypeMapping = new Map([
				["string", "StringType"],   // ColumnDataType.STRING
				["date", "DateType"],     // ColumnDataType.DATE
				["date", "TimestampType"],     // ColumnDataType.DATE
				["integer", "IntegerType"],  // ColumnDataType.INTEGER
				["big_integer", "LongType"],     // ColumnDataType.BIGINTEGER (mapped to LongType)
				["decimal", "DecimalType"],  // ColumnDataType.DECIMAL
				["boolean", "BooleanType"],  // ColumnDataType.BOOLEAN
				["binary", "BinaryType"],   // ColumnDataType.BINARY
			]);

			const headerToColumnType = new Map([
				["StringType", "string"],
				["DateType", "date"],
				["TimestampType", "date"],
				["IntegerType", "integer"],
				["LongType", "big_integer"],
				["DecimalType", "decimal"],
				["BooleanType", "boolean"],
				["BinaryType", "binary"],
			]);

			function getMappedType(sourceType) {
				return columnTypeMapping.get(sourceType) ?? null;
			}

			function filterHeadersByCaracType(headers, targetType, isList) {
				const translatedType = getMappedType(targetType);
				if (!translatedType) {
					return [];
				}
				return _.filter(headers, function (item) {
					return item.data_type.toLowerCase() === translatedType.toLowerCase() && item.list === isList;
				});
			}

			function getSourceTypeIgnoreCase(headerType) {
				if (headerType === null || headerType === undefined) {
					return null;
				}
				const lowerCaseHeaderType = headerType.toLowerCase();

				for (const key of headerToColumnType.keys()) {
					if (key.toLowerCase() === lowerCaseHeaderType) {
						return headerToColumnType.get(key).toLowerCase();
					}
				}
				return null;
			}

			function getHeaderHtmlIconByType(column) {
				if (column && column.data_type) {
					const realType = getSourceTypeIgnoreCase(column.data_type);
					return $sce.trustAsHtml(getHtmlIconByType(realType, column.list, GrammarUtils.getTypeLabel(realType)));
				}
			}

			function isTypesCompatible(caracType, headerType) {
				const mappedType = getMappedType(caracType);
				if (!mappedType || !headerType) {
					return false;
				}
				return mappedType.toLowerCase() === headerType.toLowerCase();
			}

			return RepositoryHeadersService;
		},
	]);
})();
